// export const url = "http://10.128.32.6:8080";
// export const url = "http://192.168.12.57";
export const url = "https://prepaidappapiprod.azurewebsites.net";
// export const url = "https://prepaidappapitest.azurewebsites.net";
